<template>
  <v-dialog
    v-model="dialogModel"
    max-width="600"
  >
    <v-card
      title="Concluir Requisição"
      prepend-icon="mdi-check-all"
      color="success"
    >
      <v-card-text>
        <v-alert
          type="success"
          variant="tonal"
          class="mb-4"
        >
          Você está prestes a concluir esta requisição. Esta ação marcará a requisição como concluída e encerrará o processo de compra.
        </v-alert>
        
        <v-form ref="form" @submit.prevent="handleComplete">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="invoiceNumber"
                label="Número da Nota Fiscal"
                required
                :rules="[v => !!v || 'Número da Nota Fiscal é obrigatório']"
              ></v-text-field>
            </v-col>
            
            <v-col cols="12">
              <v-textarea
                v-model="comments"
                label="Comentários Adicionais"
                rows="4"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      
      <v-divider></v-divider>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        
        <v-btn
          text="Cancelar"
          variant="plain"
          @click="close"
        ></v-btn>
        
        <v-btn
          color="success"
          text="Concluir"
          variant="flat"
          :disabled="!invoiceNumber"
          @click="handleComplete"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CompleteRequestDialog',
  
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    request: {
      type: Object,
      default: null
    }
  },
  
  data: () => ({
    invoiceNumber: '',
    comments: ''
  }),
  
  computed: {
    dialogModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  
  watch: {
    modelValue(newValue) {
      if (!newValue) {
        this.invoiceNumber = '';
        this.comments = '';
      }
    }
  },
  
  methods: {
    handleComplete() {
      if (!this.invoiceNumber) return;
      
      this.$emit('complete', this.invoiceNumber, this.comments);
      this.close();
    },
    
    close() {
      this.dialogModel = false;
      this.$emit('close');
    }
  }
}
</script> 